/**
 * PowersureCard — premium dark surface met emerald glow.
 *
 * Centrale "container" component die overal hetzelfde Powersure-gevoel
 * geeft. Geen verdere logica: alleen presentatie.
 */
import { psCls, psBgStyle } from '@/lib/powersure-theme';

export default function PowersureCard({
  children,
  className = '',
  style,
  padding = 'p-5 sm:p-7',
  variant = 'surface',
  ...rest
}) {
  const variantCls =
    variant === 'sub' ? psCls.card
    : variant === 'sub-emerald' ? psCls.cardEmerald
    : variant === 'sub-soft' ? psCls.cardSoft
    : psCls.surface;
  const variantStyle = variant === 'surface' ? psBgStyle : undefined;
  return (
    <div
      className={`${variantCls} ${padding} ${className}`}
      style={{ ...(variantStyle || {}), ...(style || {}) }}
      {...rest}
    >
      {children}
    </div>
  );
}
